interface BoxStorage {
  names: { [k: string]: string };
  box: { [k: string]: number };
  options: { [k: string]: boolean };
  product: BoxProduct;
}

interface BoxProduct {
  id: number;
  name: string;
  price: number;
  quantity: number;
  added?: boolean;
}

const LOCAL_NATIVES_BOX = "natives_box";

class LocalSettingsService {
  constructor() {}

  get<T>(key: string): T | undefined {
    const value = localStorage.getItem(key);
    return value != null ? JSON.parse(value) : undefined;
  }

  set<T>(key: string, value?: T): void {
    if (value == null) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }

  has(key: string): boolean {
    return localStorage.getItem(key) != null;
  }

  clear(): void {
    localStorage.clear();
  }
}

class NativesScheme {
  private products;
  private product: BoxProduct;
  private box: Map<number, number> = new Map<number, number>();
  private productNames: Map<number, string> = new Map<number, string>();
  private options: Map<string, boolean> = new Map<string, boolean>();
  private readonly localSettingsService = new LocalSettingsService();

  constructor() {
    jQuery(() => {
      if (this.isNativesLandingPage) {
        this.initNativesLandingPage();
      } else if (this.isNativesPage) {
        jQuery(document.body).on("post-load", () => {
          this.initNativesPage();
        });
        jQuery(document).on("yith_wacp_adding_cart_single", () => {
          this.product.added = true;
          this.updateLocalStorage();
        });
        this.initNativesPage();
      }
    });
  }

  private get nativesProductId(): number {
    if (this.product == null) {
      return 0;
    }
    return this.product.id;
  }

  private get boxMaxQuantity(): number {
    if (this.product == null) {
      return 0;
    }
    return this.product.quantity;
  }

  private get hasProductBeenAdded(): boolean {
    if (this.product.added == null) {
      return false;
    }
    return this.product.added;
  }

  private get boxPrice(): number {
    if (this.product == null) {
      return 0;
    }
    return this.product.price;
  }

  private get boxQuantity(): number {
    return Array.from(this.box.entries()).reduce((sum, a) => sum + a[1], 0);
  }

  private get isNativesPage(): boolean {
    return jQuery("body.natives-scheme").length > 0;
  }

  private get isNativesLandingPage(): boolean {
    return jQuery("body.term-native-boxes").length > 0;
  }

  private get optionsTotal(): number {
    let total = 0;
    jQuery(".box-totals input[type=checkbox]").each(function () {
      if (jQuery(this).is(":checked")) {
        total += jQuery(this).data("price");
      }
    });
    return total;
  }

  addToBox(product_id: number): void {
    this.increaseQuantity(product_id);
  }

  toggleOption(option: string): void {
    if (this.options.has(option)) {
      this.options.delete(option);
    } else {
      this.options.set(option, true);
    }
    this.updateLocalStorage();
  }

  increaseQuantity(product_id: number): void {
    if (!this.box.has(product_id)) {
      this.box.set(product_id, 0);
      this.setProductName(product_id);
    }
    let quantity = this.box.get(product_id);
    quantity++;
    this.setQuantity(product_id, quantity);
  }

  decreaseQuantity(product_id: number): void {
    let quantity = this.box.get(product_id);
    quantity--;
    this.setQuantity(product_id, quantity);
  }

  private initNativesLandingPage(): void {
    jQuery("ul.products li a.start-filling").on("click", (e) => {
      this.product = {
        id: jQuery(e.currentTarget).data("box"),
        name: jQuery(e.currentTarget).data("name"),
        quantity: jQuery(e.currentTarget).data("quantity"),
        price: jQuery(e.currentTarget).data("price"),
      };
      this.box.clear();
      this.productNames.clear();
      this.options.clear();
      const options: any = jQuery(e.currentTarget).parent().find(".box-option input:checked");
      for (let el of options) {
        const option = jQuery(el).val().toString();
        this.toggleOption(option);
      }
      this.updateLocalStorage();
      jQuery(e.currentTarget).prop("disabled", "disabled");
    });

    this.preloadFromStorage();

    if (this.nativesProductId > 0 && !this.hasProductBeenAdded) {
      jQuery("#continue-filling-box").show();
    }
  }

  private initNativesPage(): void {
    this.products = jQuery("ul.products li .natives-box-container");
    this.preloadFromStorage();

    if (!this.nativesProductId) {
      window.location.href = "/product-category/native-boxes/";
    }

    jQuery(
      "<input type='hidden' name='add-to-cart' value='" +
        this.nativesProductId +
        "' /><input type='hidden' name='product_id' value='" +
        this.nativesProductId +
        "' />"
    ).insertAfter("button.add-to-cart");

    jQuery("ul.products li a.woocommerce-LoopProduct-link").on("click", function (e) {
      e.preventDefault();
    });
    jQuery(".box-totals input[type=checkbox]").on("change", (e) => {
      const option = <string>jQuery(e.currentTarget).val();
      this.toggleOption(option);
      this.updateBoxCart();
    });
    jQuery(".toggle-box-summary").on("click", () => {
      jQuery(".box-toggle-mobile").toggle();
      jQuery("#native-box-contents").toggleClass("mobile-open");
    });

    for (let el of this.products) {
      const product_id = jQuery(el).data("id");
      this.updateBoxContainer(product_id);

      jQuery(el)
        .parent()
        .find(".jupiterx-wc-loop-product-image,.woocommerce-loop-product__title")
        .on("click", function () {
          console.log("popup");
          const popupData = {
            popupId: "jet-popup-18598",
            postId: product_id,
            listingSource: "posts",
            isJetEngine: true,
          };
          console.log(popupData);
          jQuery(window).trigger({
            type: "jet-popup-open-trigger",
            // @ts-ignore
            popupData,
          });
        });

      jQuery(el)
        .find(".quantity-increase")
        .on("click", () => {
          this.increaseQuantity(product_id);
        });

      jQuery(el)
        .find(".quantity-decrease")
        .on("click", () => {
          this.decreaseQuantity(product_id);
        });

      jQuery(el)
        .find(".quantity")
        .on("keyup change", (e) => {
          let quantity = parseInt(<string>jQuery(e.target).val());
          const current_quantity = this.productQuantity(product_id);
          if (this.boxQuantity - current_quantity + quantity > this.boxMaxQuantity) {
            quantity = this.boxMaxQuantity - (this.boxQuantity - current_quantity);
          }
          this.setQuantity(product_id, quantity);
        });

      jQuery(el)
        .find("button.add-to-box")
        .on("click", (e) => {
          const id = jQuery(e.target).parents(".natives-box-container").data("id");
          if (id != null) {
            this.addToBox(id);
          }
        });
    }
  }

  private productQuantity(product_id: number): number {
    if (!this.box.has(product_id)) {
      return 0;
    }
    return this.box.get(product_id);
  }

  private setProductName(product_id: number): void {
    if (this.productNames.has(product_id)) {
      return;
    }
    const name = jQuery(this.getBoxContainer(product_id)).parent().find("h2.woocommerce-loop-product__title").text();
    this.productNames.set(product_id, name);
  }

  private setQuantity(product_id, quantity): void {
    const el_quantity = jQuery(this.getBoxContainer(product_id)).find(".quantity");
    if (!el_quantity.length) {
      return;
    }
    el_quantity.val(quantity);
    if (quantity > 0) {
      this.box.set(product_id, quantity);
    } else {
      this.box.delete(product_id);
      this.productNames.delete(product_id);
    }
    this.updateBoxContainer(product_id);
  }

  private updateBoxContainer(product_id: number): void {
    const el = this.getBoxContainer(product_id);
    if (this.box.has(product_id)) {
      jQuery(el).find(".add-to-box").hide();
      jQuery(el).find(".natives-added").show();
    } else {
      jQuery(el).find(".add-to-box").show();
      jQuery(el).find(".natives-added").hide();
    }
    this.updateLocalStorage();
    this.updateBoxCart();
  }

  private getBoxContainer(product_id: number): HTMLElement {
    return jQuery(this.products).filter((index, el) => jQuery(el).data("id") === product_id)[0];
  }

  private updateLocalStorage(): void {
    const storage: BoxStorage = {
      names: Object.fromEntries(this.productNames),
      box: Object.fromEntries(this.box),
      options: Object.fromEntries(this.options),
      product: this.product,
    };
    this.localSettingsService.set(LOCAL_NATIVES_BOX, storage);
  }

  private updateBoxCart() {
    let html = "";
    if (this.box.size > 0) {
      html += "<h3>Natives added</h3><ul>";
      this.box.forEach((quantity, product_id) => {
        const product_name = this.productNames.get(product_id);
        html += `<li><b>${quantity}x</b> ${product_name}<input type="hidden" name="plants[${product_id}]" value="${quantity}"/></li>`;
      });
      html += "</div>";
    }
    const cart_total = this.boxPrice + this.optionsTotal;
    jQuery("#box-total").html("$" + cart_total.toFixed(2));
    jQuery("#box-list").html(html);
    jQuery(".box-quantity").html(this.boxQuantity.toString());
    jQuery(".box-max-quantity").html("/" + this.boxMaxQuantity);
    if (this.boxQuantity >= this.boxMaxQuantity) {
      jQuery("button.quantity-increase,button.add-to-box").prop("disabled", "disabled");
      jQuery("button.add-to-cart").prop("disabled", null);
    } else {
      jQuery("button.quantity-increase,button.add-to-box").prop("disabled", null);
      jQuery("button.add-to-cart").prop("disabled", "disabled");
    }
  }

  private preloadFromStorage() {
    const storage: BoxStorage = this.localSettingsService.get(LOCAL_NATIVES_BOX);
    if (storage == null) {
      return;
    }
    Object.entries(storage.names).forEach((names) => {
      this.productNames.set(parseInt(names[0]), names[1]);
    });
    Object.entries(storage.box).forEach((box) => {
      this.box.set(parseInt(box[0]), box[1]);
    });
    Object.entries(storage.options).forEach((option) => {
      this.options.set(option[0], option[1]);
    });
    this.box.forEach((quantity, product_id) => {
      this.setQuantity(product_id, quantity);
    });
    this.options.forEach((toggle, option) => {
      jQuery(".box-option input[value=" + option + "]").prop("checked", "checked");
    });
    this.product = storage.product;
  }
}

const _natives = new NativesScheme();
